import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { NearDupTextGroupingManager } from '../../../managers/near-dup-text-grouping.manager';
import { LexbeCase } from '../../../models/case.model';
import { Collection } from '../../../models/ui/collection.model';
import { NearDupTextGrouping } from '../../../models/ui/near-dup-text-grouping.model';
import { HelpService } from '../../../services/help.service';

@Component({
    selector: 'lex-near-dup-text-groupings',
    templateUrl: './near-dup-text-groupings.component.html',
    styleUrls: ['./near-dup-text-groupings.component.scss'],
    standalone: false
})
export class NearDupTextGroupingsComponent implements OnInit {

	nearDupTextGroupings: NearDupTextGrouping[] = [];
	currentCase: LexbeCase;
	totalNearDupTextGroups: number;
	pageIndex: number = 0;
	pageSize: number = 20;
	pageSizeOptions: number[] = [20, 40, 60, 80, 100];
	refreshing: boolean = false;

	constructor(private helpService: HelpService, private nearDupTextGroupingManager: NearDupTextGroupingManager) { }

	ngOnInit() {
		this.getNearDupTextGroupings(0, this.pageSize);

		this.helpService.updateHelpLink("browse-menu/text-groups");
	}

	public getPage($event: PageEvent) {
		this.pageSize = $event.pageSize;
		this.pageIndex = $event.pageIndex;
		this.getNearDupTextGroupings(this.pageIndex, this.pageSize);
	}

	private getNearDupTextGroupings(index: number, pageSize: number) {
		this.refreshing = true;
		this.nearDupTextGroupingManager.getNearDupTextGroupings(index, pageSize)
			.subscribe((groups: Collection<NearDupTextGrouping>) => {
				this.refreshing = false;
				this.nearDupTextGroupings = groups.items;
				this.totalNearDupTextGroups = groups.totalItems;
			}, () => {
				this.refreshing = false;
			});
	}

}
